<ion-content>
  <div class="menu-header">
    <h1 class="menu-app-name">{{ appName }}</h1>
  </div>

  <ion-list lines="none" class="menu-list">
    @for (item of menuItems(); track item.label) {
      <ion-item
        [routerLink]="item.route"
        routerDirection="forward"
        routerLinkActive="menu-item-active"
        [routerLinkActiveOptions]="{ exact: !item.matchChildren }"
        [lines]="'none'"
        class="menu-item"
        (click)="closeMenu()"
      >
        <ion-icon [name]="item.icon" slot="start" class="menu-icon"></ion-icon>
        <ion-label class="menu-label">{{ item.label | translate }}</ion-label>
      </ion-item>
    }
  </ion-list>

  <div class="menu-footer">
    <ion-list lines="none">
      @for (item of bottomItems; track item.label) {
        <ion-item
          [routerLink]="item.route"
          routerDirection="forward"
          routerLinkActive="menu-item-active"
          [routerLinkActiveOptions]="{ exact: true }"
          [lines]="'none'"
          class="menu-item"
          (click)="closeMenu()"
        >
          <ion-icon [name]="item.icon" slot="start" class="menu-icon"></ion-icon>
          <ion-label class="menu-label">{{ item.label | translate }}</ion-label>
        </ion-item>
      }
    </ion-list>
  </div>
</ion-content>
